$(document).ready(function(){
  //Switch Images and Change Select When a Swatch is Clicked
  $('.main-product-color-switch .switch-color-element').click(function(){
    var form = $(this).closest('form.data-variants');
    var colorValue = $(this).attr('data-value');

    //Swaps Image on Swatch Click
    var selectedImage = $(this).attr('data-image');
    $(this).closest('.content-product-list').find('.collection-product-image').attr('src', selectedImage);

    //Selects Swatch Radio Button
    $(this).find('input[type="radio"]').prop("checked", true);

    //Change Value of Hover Color Dropdown
    form.find('.select-color').val(colorValue);
    form.find('.select-color').trigger('change');
  });

  //Switch Variant Ids, Images, and select swatch
  $('.product-option select.variant-select').change(function(){
    var form = $(this).closest('form.data-variants');
    var optionSelector = '';
    var submitButton = form.find('input[type="submit"]');

    //If Select Changed was color swap images
    if($(this).attr('data-type') == 'color'){
      var switchColorElement = form.find('.switch-color-element[data-value="'+$(this).val()+'"]');
      var selectedImage = switchColorElement.attr('data-image');
      $(this).closest('.content-product-list').find('.collection-product-image').attr('src', selectedImage);
      switchColorElement.find('input[type="radio"]').prop('checked',true);
      if($(this).attr('data-slider')=='true'){
        var mainContent = $(this).closest('.main-content-view');
        var mainSlider = mainContent.find('.main-images');
        var navSlider = mainContent.find('.nav-main');

        mainSlider.slick('slickUnfilter');
        navSlider.slick('slickUnfilter');
        var filterValue = '[data-color="'+$(this).val()+'"]';
        mainSlider.slick('slickFilter',filterValue);
        navSlider.slick('slickFilter',filterValue);
        navSlider.find('.slick-slide').each(function(index){
          $(this).unbind('click');
          $(this).click(function(){
            navSlider.slick('slickGoTo',index);
          });
        });
        navSlider.find('.item-nav:first-child').trigger('click');
        form.find('.product-frame span').text($(this).val());
      }
    }
    //Get Option JQuery Selector to find the option
    form.find('.select-product-options').each(function(){
      var optionNumber = $(this).attr('data-option');
      var optionValue = $(this).val();
      optionSelector += '[data-option'+optionNumber+'="'+optionValue+'"]';
    });

    //Find Option - If it exists set add to cart ID, if not disable add to cart
    var variantOption = form.find('option'+optionSelector);
    if(variantOption.length > 0){
      if($(variantOption).attr('data-available') == 'true'){
        variantOption.parent().val(variantOption.val());
        submitButton.attr('disabled',false);
        submitButton.attr('data-cart-add',variantOption.val());
        submitButton.val('Add to Cart');
      }else{
        submitButton.attr('disabled',true);
        submitButton.val('Sold Out');
      }
    }else{
      submitButton.attr('disabled',true);
      submitButton.val('Sold Out');
    }
  });

  //Selects the first swatch on the product page
  $('#MainProduct .main-product-color-switch .switch-color-element').first().trigger('click');

  //Change Quantity of Add To Cart
  $('.product-option select.quantity-select').change(function(){
    var form = $(this).closest('form.data-variants');
    var submitButton = form.find('input[type="submit"]');
    submitButton.attr('data-cart-quantity', $(this).val());
  });

  // Collection Page filters
  $('.filters-products .sub-data .input-value').on('click', function() {
    $(this).parent().find('.input-value').not(this).prop('checked', false);
    var filterData = $(this).val();
    var activeFilters = ""
    var rootUrl = $('#collection-url').attr('data-url');

    $('.filters-products .sub-data .input-value:checked').each(function() {
      activeFilters += $(this).val()+"+";
    });

    activeFilters = activeFilters.substring(0, activeFilters.length-1);

    window.location.href = rootUrl+"/"+activeFilters;
  });

  //Set the Current Filter based on the URL on the collection page
  function currentFilterState(){
    //Sets filter checkbox state depending on url
    var urlSegment = document.URL.substring(document.URL.lastIndexOf('/')+1);
    if(urlSegment){
      var activeFilters = urlSegment.split('+');
      for(var i = 0; i < activeFilters.length; i++){
        $(".filters-products input[value='"+activeFilters[i]+"']").prop("checked", true);
      }
    }
  }

  currentFilterState();
});
